import Navbar from "./components/Navbar";
import Carousel from "./components/Carousel";
import Hero from "./components/Hero";
import TopArticles from "./components/Top_Articles";
import Footer from "./components/Footer";

export function App() {

  return (
    <>
      <Navbar />
      <Carousel />
      <Hero />
      <TopArticles />
      <Footer />
    </>
  );
}

